import { CheckIcon } from '@phosphor-icons/react';

import { MEDIA } from '@/assets/media';
import { useContent } from '@/content/ContentContext';
import { BriefForm } from '@/features/brief/BriefForm';
import { Chapter, ChapterColumn } from '@/features/journey/Chapter';
import { cx } from '@/ui/classNames';
import { Container } from '@/ui/Layout/Container';
import { RevealText } from '@/ui/Reveal/RevealText';
import { typography } from '@/ui/Typography/typography';

import styles from './Brief.module.css';

/**
 * Chapitre 06, votre projet, face au trou noir « Lancement ». Chaque étape
 * validée en rapproche la caméra ; l'envoi la fait plonger (voir useBriefCosmos).
 */
export function BriefSection() {
  const { brief } = useContent();

  return (
    <Chapter
      chapter="brief"
      id="brief"
      className={styles.section}
      aria-labelledby="brief-title"
      poster={MEDIA.nebula}
    >
      <Container>
        <ChapterColumn chapter="brief" className={styles.column}>
          <div className={styles.intro}>
            <RevealText id="brief-title" className={cx(typography.heading, typography.h2)}>
              {brief.title} <span className={typography.accent}>{brief.titleAccent}</span>
            </RevealText>
            <p className={typography.lead}>{brief.lead}</p>
          </div>

          <div className={styles.frame}>
            <div className={styles.panel}>
              <BriefForm />
            </div>
          </div>

          <ul className={styles.promises}>
            {brief.promises.map((promise) => (
              <li key={promise} className={styles.promise}>
                <span className={styles.promiseIcon} aria-hidden="true">
                  <CheckIcon size={12} weight="bold" />
                </span>
                {promise}
              </li>
            ))}
          </ul>
          <p className={styles.direct}>
            {brief.directContact.label}
            <br />
            <a className={styles.directLink} href={`mailto:${brief.directContact.email}`}>
              {brief.directContact.email}
            </a>
          </p>
        </ChapterColumn>
      </Container>
    </Chapter>
  );
}
